<div class="flex flex-1 flex-row">
	<div class="w-1/2">
		<h2>Common expenses</h2>
		<div class="mr-5 mt-5">
			<app-input
				label="Adjustment title"
				[(ngModel)]="adjustment.title"
				class="mt-3"
			></app-input>
			<app-input
				type="cents"
				label="Monthly fees"
				name="fees"
				class="mt-3"
				[startIcon]="ICON.DOLLAR"
				[(ngModel)]="adjustment.fees"
				(ngModelChange)="changed()"
				[testHook]="testHooks.MonthlyFees"
			></app-input>
			<div class="mt-3">
				<div class="flex gap-3 items-center w-full">
					<app-checkbox
						class="w-full"
						[ngClass]="{ 'opacity-50': disableApplyHstField() }"
						label="Apply HST ({{ hst | percent }})"
						[(ngModel)]="adjustment.applyHst"
						(ngModelChange)="changed()"
						[disabled]="disableApplyHstField()"
						[testHook]="testHooks.ApplyHstCheckbox"
					></app-checkbox>
					<i-tabler
						*ngIf="disableApplyHstField()"
						class="h-5 w-5 text-gray-900"
						name="info-square-rounded"
						matTooltip="HST applicable to commercial condo units only"
					></i-tabler>
				</div>
			</div>
			<app-input
				type="cents"
				[label]="vendorShareLabel"
				name="vendorShare"
				class="mt-3"
				[startIcon]="ICON.DOLLAR"
				[ngModel]="vendorShare"
				[disabled]="true"
				[testHook]="testHooks.VendorShare"
			></app-input>
			<app-radio-group
				class="mt-3"
				[items]="vendorPaidItems"
				label="Vendor will have paid full amount"
				name="vendorPaid"
				[(ngModel)]="adjustment.vendorPaid"
				(ngModelChange)="changed()"
				type="compact"
				[testHook]="testHooks.VendorWillHavePaidFullAmountRadioGroup"
			></app-radio-group>
			<app-input
				type="cents"
				label="Vendor will have paid"
				name="vendorPaidAmount"
				class="mt-3"
				[startIcon]="ICON.DOLLAR"
				[(ngModel)]="adjustment.vendorPaidAmount"
				(ngModelChange)="changed()"
				[disabled]="adjustment.vendorPaid === 'yes'"
				[testHook]="testHooks.VendorWillHavePaid"
			></app-input>
			<app-input
				*ngIf="creditAmount >= 0"
				type="cents"
				label="Credit vendor"
				name="credit"
				class="mt-3"
				[startIcon]="ICON.DOLLAR"
				[ngModel]="creditAmount"
				[disabled]="true"
				[testHook]="testHooks.CreditVendor"
			></app-input>
			<app-input
				*ngIf="creditAmount < 0"
				type="cents"
				label="Credit purchaser"
				name="credit"
				class="mt-3"
				[startIcon]="ICON.DOLLAR"
				[ngModel]="creditAmount * -1"
				[disabled]="true"
				[testHook]="testHooks.CreditPurchaser"
			></app-input>
			<div class="mt-3">
				<app-checkbox
					label="Include all details in document"
					[(ngModel)]="adjustment.details"
					[testHook]="testHooks.IncludeAllDetailsInDocumentCheckbox"
				></app-checkbox>
			</div>
		</div>
		<div class="flex justify-between mr-5 mt-5">
			<app-button
				btn="tertiary"
				class="mr-5"
				(click)="cancelModal()"
				[testHook]="testHooks.CancelButton"
				>Cancel</app-button
			>
			<app-button (click)="saveModal()" [testHook]="testHooks.SaveButton"
				>Save</app-button
			>
		</div>
	</div>
	<div class="w-1/2">
		<app-container type="dark" title="Details">
			<div class="flex flex-1 flex-col">
				<div class="mb-8">
					<div class="flex justify-between items-start mb-3">
						<div>Monthly common expenses</div>
						<div>{{ adjustment.fees | centsToDollars }}</div>
					</div>
					<div class="flex justify-end items-start mb-3">
						<div>
							&nbsp;<strong *ngIf="adjustment.applyHst"
								>HST ({{ hst | percent }}) =
								{{ hstAmount | centsToDollars }}</strong
							>
						</div>
					</div>
					<div class="flex justify-between items-start mb-3">
						<div>{{ vendorShareLabel }}</div>
						<div>{{ vendorShare | centsToDollars }}</div>
					</div>
					<div class="flex justify-between items-start mb-8">
						<div>Vendor has paid</div>
						<div>{{ adjustment.vendorPaidAmount | centsToDollars }}</div>
					</div>
					<div class="flex justify-end items-start">
						<div *ngIf="creditAmount >= 0">
							<strong
								>Credit Vendor = {{ creditAmount | centsToDollars }}</strong
							>
						</div>
						<div *ngIf="creditAmount < 0">
							<strong
								>Credit Purchaser =
								{{ creditAmount * -1 | centsToDollars }}</strong
							>
						</div>
					</div>
				</div>
			</div>
		</app-container>
	</div>
</div>
